// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9177e220","64":"b881855b","417":"16944473","449":"ca2a5b46","480":"9689a041","623":"8ff229cd","686":"6579ed2c","692":"ee98ce3e","707":"acdd463a","807":"01f79ac9","924":"b598b390","952":"2202dcff"}[chunkId] + ".chunk.js";
};